import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface MessageData {
    message: string;
    class?: string;
}

@Component({
    selector: 'app-notice',
    templateUrl: './notice.component.html',
    styleUrls: ['./notice.component.css'],
})
export class NoticeComponent implements OnInit {
    public msgClass = 'alert-success';
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: MessageData,
        public dialogRef: MatDialogRef<NoticeComponent>
    ) {}

    ngOnInit(): void {
        if (this.data.class) {
            this.msgClass = `alert-${this.data.class}`;
        }
    }

    public onNoClick(): void {
        this.dialogRef.close();
    }
}
